import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess1033Status: 'idle',
    startProcess1033Error: undefined as any,
    loadUserParamsProcess1033Status: 'idle',
    loadUserParamsProcess1033Error: undefined as any,

    process1033List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess1033 = createAsyncThunk('process1033Slice/startProcess1033', async ({ process1033 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess1033/`,
        prepareData(process1033),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess1033Status } = getState().process1033Slice
        return startProcess1033Status !== 'pending'
    }
})

export const loadUserParamsProcess1033 = createAsyncThunk('process1033Slice/loadUserParamsProcess1033', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess1033/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess1033Status } = getState().process1033Slice
        return loadUserParamsProcess1033Status !== 'pending'
    }
})

const Process1033Slice = createSlice({
    name: 'process1033Slice',
    initialState,
    reducers: {
        resetstartProcess1033: (state) => {
            state.job = undefined
            state.startProcess1033Error = undefined
        },
        resetstartProcess1033Error: (state) => {
            state.startProcess1033Error = undefined
        },
        resetloadUserParamsProcess1033: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess1033Error = undefined
        },
        resetloadUserParamsProcess1033Error: (state) => {
            state.loadUserParamsProcess1033Error = undefined
        },
        removeFromProcess1033ListById: (state, action) => {
            state.process1033List = state.process1033List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess1033ListByIds: (state, action) => {
            state.process1033List = state.process1033List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process1033List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess1033Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process1033List = []
            state.startProcess1033Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess1033.pending, (state) => {
            state.startProcess1033Status = 'pending'
            state.startProcess1033Error = undefined
        })
        builder.addCase(startProcess1033.fulfilled, (state, action) => {
            state.startProcess1033Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess1033.rejected, (state, action) => {
            state.startProcess1033Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess1033Error = action.error.message
            } else {
                state.startProcess1033Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess1033.pending, (state) => {
            state.loadUserParamsProcess1033Status = 'pending'
            state.loadUserParamsProcess1033Error = undefined
        })
        builder.addCase(loadUserParamsProcess1033.fulfilled, (state, action) => {
            state.loadUserParamsProcess1033Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess1033.rejected, (state, action) => {
            state.loadUserParamsProcess1033Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess1033Error = action.error.message
            } else {
                state.loadUserParamsProcess1033Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess1033,
    resetstartProcess1033Error,
    resetloadUserParamsProcess1033,
    resetloadUserParamsProcess1033Error,
    removeFromProcess1033ListById,
    removeFromProcess1033ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process1033Slice.actions
export default Process1033Slice.reducer
